export const EntityTypeList_lines_entityType = `lines.entityType`;
export const MasterGroup_forType = `forType`;
export const DocumentBook_documentType = `documentType`;
export const Account_chartWhenDebit = "chartWhenDebit";
export const AUTestDef_phase = "phase";
export const AUPhase_fullHierarchyPath = "fullHierarchyPath";
export const CriteriaDefinition_forType = "forType";
export const CriteriaDefinition_useInList = "useInList";
export const ReportDefinition_reportType = "reportType";
export const DashBoard_details_dashBoardGroup = "details.dashBoardGroup";
export const DashBoardGroup_orderInMenu = "orderInMenu";
export const ReportGroup_orderInMenu = "orderInMenu";
export const ReportDefinition_groupsIds = "groupsIds";
export const CriteriaDefinition_criteria = "criteria";
export const DiscussionRecord_attachment1 = "attachment1";
export const DiscussionRecord_attachment2 = "attachment2";
export const DiscussionRecord_attachment3 = "attachment3";
export const DiscussionRecord_attachment4 = "attachment4";
export const DiscussionRecord_discussion = "discussion";
export const DiscussionRecord_ref1 = "ref1";
export const DiscussionRecord_ref2 = "ref2";
export const DocumentBook_printOnSave = "printOnSave";
export const CRMDevelopmentRequest_concernedEntity = "concernedEntity";
export const CRMDevelopmentRequest_applicationLog = "applicationLog";
export const ItemCategory_categoryLevel = "categoryLevel";
